import { Navigate, Outlet } from "react-router-dom"
import { useAppSelector } from "../../stateManagement/hooks/redux"

export function RequireAuth() {
    const token = useAppSelector(state => state.auth.tokens.app)
    return (
        token
            ? <Outlet />
            : <Navigate to="/login" />
    )
}